import client from './client';
import type { SMSProvider } from '../types';

export interface SMSProviderRequest {
  name: string;
  provider_type: 'twilio' | 'vonage' | 'generic' | 'httpsms';
  account_sid?: string;
  auth_token?: string;
  api_key?: string;
  api_secret?: string;
  from_number: string;
  extra_config?: string;
  inbound_enabled?: boolean;
  report_keyword?: string;
}

export type SMSProviderSaveResponse = SMSProvider & {
  webhook_token?: string;
  webhook_path?: string;
};

export const smsProvidersApi = {
  getAll: () => client.get<SMSProvider[]>('/sms-providers/'),
  getById: (id: number) => client.get<SMSProvider>(`/sms-providers/${id}`),
  create: (data: SMSProviderRequest) => client.post<SMSProviderSaveResponse>('/sms-providers/', data),
  update: (id: number, data: SMSProviderRequest) => client.put<SMSProviderSaveResponse>(`/sms-providers/${id}`, { ...data, id }),
  delete: (id: number) => client.delete<{ success: boolean; message: string }>(`/sms-providers/${id}`),
};
